import React from 'react';
import { ScrollView, View } from 'react-native';
import useMediumScreen from 'hooks/useMediumScreen';
import ProductListProps from 'types/components/ProductListProps';
import ProductItem from './ProductItem';
import { styles } from 'styles/components/productList';

export default ({
  products,
  onChangeQuantity,
  setCurrentShoppingCart,
  currentShoppingCart,
  generalColor,
}: ProductListProps): JSX.Element => {
  const mediumScreen = useMediumScreen();

  const renderMediumScreen = (): JSX.Element => {
    return (
      <>
        <ScrollView
          style={[
            styles.cardColumnSmall,
            currentShoppingCart && currentShoppingCart?.detail.length > 0 && { marginBottom: 85 },
          ]}
        >
          {products.map((product, index) => (
            <ProductItem
              key={index}
              product={product}
              onChangeQuantity={onChangeQuantity}
              setShoppingCart={setCurrentShoppingCart}
              shoppingCart={currentShoppingCart}
              generalColor={generalColor}
            />
          ))}
        </ScrollView>
      </>
    );
  };

  const renderLargeScreen = (): JSX.Element => {
    return (
      <View
        style={[
          styles.cardsContainerLarge,
          currentShoppingCart && currentShoppingCart?.detail.length > 0 && { marginBottom: 100 },
        ]}
      >
        <View style={styles.cardColumnLarge}>
          {products.map((product, index) => (
            <ProductItem
              key={index}
              product={product}
              onChangeQuantity={onChangeQuantity}
              setShoppingCart={setCurrentShoppingCart}
              shoppingCart={currentShoppingCart}
              generalColor={generalColor}
            />
          ))}
        </View>
      </View>
    );
  };

  return <>{mediumScreen ? renderLargeScreen() : renderMediumScreen()}</>;
};
